import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Calendar, Clock, Share2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import NCUIImage from "../../../assets/images/NCUI Harsh.jpg";

const NCUIFelicitationPost = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex items-center justify-between mb-8">
          <motion.button
            onClick={() => navigate("/articles/blog")}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center text-red-600 hover:text-red-700 group"
          >
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
            Back to Blog
          </motion.button>
          <motion.button
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigator.share?.({ title: document.title, url: window.location.href })}
            className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <Share2 className="w-4 h-4" />
            Share
          </motion.button>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex flex-wrap items-center gap-4 mb-6">
            <span className="px-4 py-1.5 bg-red-100 text-red-600 rounded-full text-sm font-medium">
              Recognition
            </span>
            <div className="flex items-center text-gray-500 text-sm">
              <Calendar className="w-4 h-4 mr-1.5" />
              December 2024
            </div>
            <div className="flex items-center text-gray-500 text-sm">
              <Clock className="w-4 h-4 mr-1.5" />
              4 min read
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            NCUI Felicitates Me as ICA Youth Committee President
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
            During the Annual General Meeting of NCUI held in New Delhi, I was graciously felicitated for being elected as the President of the ICA Youth Committee
          </p>

          <div className="mb-12 -mx-4 sm:mx-0">
            <img
              src={NCUIImage}
              alt="NCUI Felicitation - ICA Youth Committee President"
              className="w-full rounded-none sm:rounded-xl shadow-2xl"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              During the Annual General Meeting (AGM) of the National Cooperative Union of India (NCUI) held on Saturday in New Delhi, I was graciously felicitated for being elected as the President of the International Cooperative Alliance (ICA) Youth Committee.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              I am honored to have made history as the first Indian to hold this prestigious position.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">The ICA Youth Committee</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              The ICA Youth Committee is a global thematic body of the International Cooperative Alliance that represents young cooperative leaders across the world. Through this platform, I am working to strengthen youth participation in cooperatives by ensuring their voices are heard in policymaking, promoting cooperative entrepreneurship, and nurturing leadership through toolkits, youth forums, and exchange programs.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              I have taken over this role from Ana Aguirre from Spain, who served as the inaugural President under the current structure. After she stepped down earlier this year, elections were held during the ICA meeting in Manchester, where I was elected.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">International Year of Cooperatives 2025</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              My election comes at a significant moment, as the United Nations has declared 2025 as the International Year of Cooperatives. This recognition highlights the need for strong youth leadership in tackling global challenges such as climate change, economic inequality, and sustainable livelihoods—responsibilities I am committed to advancing.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              During the felicitation at the AGM, NCUI leaders expressed their pride and emphasized that this marks a new milestone for India in the global cooperative movement.
            </p>

            <p className="text-lg text-gray-500 mt-12 mb-8">- Harsh M. Sanghani</p>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <button
                onClick={() => navigate("/articles/blog")}
                className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
              >
                <ArrowLeft className="w-5 h-5" />
                Read More Articles
              </button>
            </div>
          </div>
        </motion.div>
      </article>
    </div>
  );
};

export default NCUIFelicitationPost;
